<template>
  <div>
    <mingxi  :mingxiMain_type="2" :mingxi_type="1" > </mingxi> 
  </div>
</template>
<script>
import mingxi from '../../tongyong/adminMingxi.vue'
export default {

  components: {
    mingxi: mingxi 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
